'use strict';

const Moment = require('moment');
const Backbone = require('backbone');
const Key = require('common/domain/value/key');
const AnnouncementCategory = require('../value/announcement-category');

class AnnouncementModel extends Backbone.Model {
    constructor(attributes) {
        super(attributes);
    }

    static get defaults() {
        return {
            title: '',
            description: '',
            state: '',
            publishedAt: null,
            expiredAt: '',
            key: '',
        };
    }

    static getCategoryName() {
        return AnnouncementCategory.getAnnouncementName();
    }

    getCategoryName() {
        return AnnouncementModel.getCategoryName();
    }

    getID() {
        return this.get('id');
    }

    getKey() {
        return new Key(this.get('key'));
    }

    getTitle() {
        return this.get('title');
    }

    getDescription() {
        return this.get('description');
    }

    getState() {
        return this.get('state');
    }

    getStateChoices() {
        return this.get('stateChoices');
    }

    getPublishedAt() {
        return this.get('publishedAt');
    }

    getExpiredAt() {
        return this.get('expiredAt');
    }

    isPublished() {
        return this.getState() === 'published';
    }

    isDisplayed() {
        // 掲載終了日時が現在時刻より後、もしくは設定されていない場合は表示する
        return this.isPublished() && (Moment(this.getExpiredAt()).isAfter(Moment()) || this.getExpiredAt() == null);
    }

    isFilled() {
        return this.getTitle() && this.getDescription();
    }
}

module.exports = AnnouncementModel;



// WEBPACK FOOTER //
// ./feedback/domain/entity/announcement.js